import { Trans, useTranslation } from "react-i18next";
import image from '../../img/PremiumService/become.png';
import Button from "../Button";

const Become = () => {
    const { t } = useTranslation();
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px] xl:px-[80px]">
                <div className="md:grid md:items-center flex flex-col grid-cols-2 gap-0 md:gap-[40px] xl:gap-[95px]">
                    <div className="text-center md:text-left">
                        <h2 className="text-[#63ABFF] font-[700] text-[28px] xl:text-[45px]">
                            <Trans
                                i18nKey="premium.become.title"
                                components={{ span: <span className="text-[#0C2780] text-[28px] xl:text-[19px]" /> }}
                            />
                            <br /><span className="text-[#0C2780]">ARVEST SOLID FD</span>
                        </h2>
                        <p className="mt-[30px] md:mt-[15px] max-w-[100%] md:max-w-[489px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            <Trans>
                                {t('premium.become.text_01')}
                            </Trans>
                        </p>
                        <p className="mt-[13px] md:mt-[15px] max-w-[100%] md:max-w-[489px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('premium.become.text_02')}
                        </p>
                        <Button className="mt-[40px] hidden md:flex" color="#15318D" text="#EFEFEF" />
                    </div>
                    <div className="flex justify-center items-center md:mt-0 mt-[45px]">
                        <img className="w-[100%] md:max-w-[523px] sm:max-w-[340px] max-w-[256px]" src={image} alt='' />
                    </div>
                </div>
            </div>
        </section>
    )
};

export default Become;
